<div class="glossary"></div>
{{#if footnotes}}
<div class="references">
  {{#each footnotes}}
  <div class="reference">
    <sup>{{indexToCount @index}}</sup>
    {{#if url}}
      <a href="{{url}}" target="_blank" rel="noopener noreferrer">{{#if text}}{{t text}}{{else}}{{url}}{{/if}}
        <span class="screen-reader-content">{{t "newWindow"}}</span>
      </a>
    {{else}}
      <span>{{t text}}</span>
    {{/if}}
  </div>
  {{/each}}
</div>
{{/if}}